import _ from 'lodash';

const presetOrderGallery = [
  {
    label: 'counter_picture',
    order: 1,
  },
  {
    label: 'three_quarters_front_right_picture',
    order: 2,
  },
  {
    label: 'front_picture',
    order: 3,
  },
  {
    label: 'three_quarters_front_picture',
    order: 4,
  },
  {
    label: 'left_side_picture',
    order: 5,
  },
  {
    label: 'inside_front_picture',
    order: 6,
  },
  {
    label: 'inside_back_picture',
    order: 7,
  },
  {
    label: 'dashboard_picture',
    order: 8,
  },
  {
    label: 'three_quarters_back_left_picture',
    order: 9,
  },
  {
    label: 'back_picture',
    order: 10,
  },
  {
    label: 'trunk_picture',
    order: 11,
  },
  {
    label: 'three_quarters_back_picture',
    order: 12,
  },
  {
    label: 'right_side_picture',
    order: 13,
  },
];

export const orderGalleryPictures = (gallery) => {
  let orderedGallery = [];
  const disorderedGallery = [];

  _.forEach(gallery, (value, label) => {
    const picture = { value, key: label };
    // chek if label exist in order table
    const foundedLabel = _.filter(presetOrderGallery, { label });
    if (!_.isEmpty(foundedLabel)) {
      orderedGallery[foundedLabel[0].order] = picture;
    } else {
      disorderedGallery.push(picture);
    }
  });
  orderedGallery = _.filter(orderedGallery, (picture) => picture != null).concat(disorderedGallery);

  return orderedGallery;
};

export const getAllGalleryPictures = (data) => {
  const listAllGallery = [];
  const ref = data?.totals ? Object.entries(data?.totals)?.[0]?.[0] : undefined;
  _.forEach(data, (value) => {
    _.forEach(value, (value2, key2) => {
      if (key2 === 'damages') {
        value2.forEach((damage) => {
          if (damage.damage_picture && damage.referential === ref)
            listAllGallery.push({ value: ['image', damage.damage_picture], key: damage.element });
          if (damage.damage_picture2 && damage.referential === ref)
            listAllGallery.push({ value: ['image', damage.damage_picture2], key: `${damage.element}_2` });
        });
      }
      if (value2?.[0] === 'image') listAllGallery.push({ value: value2, key: key2 });
    });
  });
  return listAllGallery;
};
